module.exports = __webpack_public_path__ + "static/turquia-014-aa033e5655e8c8c266f987689721588b.jpg";